export default function StepGuide() {
  const steps = [
    {
      number: '01',
      icon: 'ri-phone-line',
      title: 'Contacto inicial',
      description: 'Llámanos o rellena el formulario. Te atenderemos de inmediato para conocer tus necesidades.'
    },
    {
      number: '02',
      icon: 'ri-file-list-3-line',
      title: 'Presupuesto gratuito',
      description: 'Visitamos el piso y te ofrecemos un presupuesto detallado sin compromiso alguno.'
    },
    {
      number: '03',
      icon: 'ri-calendar-check-line',
      title: 'Planificación',
      description: 'Acordamos la fecha y hora que mejor te convenga para realizar el vaciado.'
    },
    {
      number: '04',
      icon: 'ri-truck-line',
      title: 'Vaciado profesional',
      description: 'Nuestro equipo realiza el vaciado completo de forma rápida y eficiente, con reciclaje y eliminación responsable de todos los materiales.',
      hasLink: true
    }
  ];

  return (
    <section id="guia" className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            ¿Cómo funciona nuestro servicio?
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Un proceso simple y transparente en 4 pasos para vaciar tu piso sin complicaciones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white rounded-xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 w-12 h-12 sm:w-16 sm:h-16 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-base sm:text-xl shadow-lg">
                {step.number}
              </div>
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-50 rounded-lg flex items-center justify-center mb-4 sm:mb-6 mt-3 sm:mt-4">
                <i className={`${step.icon} text-xl sm:text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                {step.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {step.description}
                {step.hasLink && (
                  <>
                    {' '}
                    <a 
                      href="https://deixalleries.amb.cat/" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-teal-600 hover:text-teal-700 underline cursor-pointer"
                    >
                      reciclaje y eliminación responsable
                    </a>
                    {' de todos los materiales.'}
                  </>
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
